import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withNamespaces, WithNamespaces } from 'react-i18next';


const Mountains: React.FunctionComponent<WithNamespaces> = ({ t }) => {
    return (
        <IconButton aria-label="mountains">
            <SvgIcon viewBox="-3 -5 39 39" preserveAspectRatio="xMinYMin meet">
                <title>{t('icons.mountains')}</title>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="2.0.4-Full-Screen-MOTORWAY" transform="translate(-215.000000, -23.000000)" fill="#FFFFFF">
                        <g id="Icon_Mountain" transform="translate(214.000000, 23.000000)">
                            <path d="M28.0787692,19.8254 L28.8359231,18.3274 L33.3736154,27.3 L24.2982308,27.3 L3.98453846,27.3 L1.00823077,27.3 L8.25153846,12.6714 L9.83123077,15.8634 L17.9428462,0 L28.0787692,19.8254 Z M21.4134615,8.925 L17.9480769,1.834 L14.5480769,8.925 L16.0192308,10.5 L17.9807692,7.875 L19.9423077,10.5 L21.4134615,8.925 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </SvgIcon >
        </IconButton >
    );
}

export default withNamespaces()(Mountains);